// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"LeafSpacer_Wrapper__BcXt6","Image":"LeafSpacer_Image__1SgXh"};